import styled, { createGlobalStyle } from 'styled-components';

export const Root = styled.div`
	grid-area: advertImg;
	position: relative;
	width: 100%;
	max-width: 100%;
	margin-top: 14px;
`;

export const SlideStyle = createGlobalStyle`
	.apartSmallSlider {
		padding: 0;
		min-width: 100%;
		width: 0;

		.slick-list {
			overflow: hidden;
			height: 100%;
		}

		.slick-track {
			display: flex;
			height: 100%;
			line-height: 0;
			font-size: 0;
		}

		.slick-slide {
			display: inline-block;
			padding: 0 2.5px;
			box-sizing: border-box;
		}
	}
`;

export const SliderRoot = styled.button`
	display: block;
	position: relative;
	width: 100%;
	height: 75px;
	margin: 0;
	padding: 0;
	cursor: pointer;
	box-sizing: border-box;
	box-shadow: none;
	border: none;
	transition: opacity 0.2s;
	overflow: hidden;
	${({ theme }) => theme.typography.textBoldL};
	font-size: 32px;
	color: #fff;
	border-radius: 4px;

	&:hover {
		${({ $withHover }) => $withHover && `opacity: 0.8;`};
		.imgCoverText {
			display: flex;
		}
	}

	.imgCoverText {
		display: none;
	}
`;

export const SlideImg = styled.figure`
	position: relative;
	width: 100%;
	margin: 0;
	overflow: hidden;
	z-index: 1;
	padding: 0;
	height: 100%;

	img {
		position: absolute;
		top: 50%;
		left: 50%;
		width: ${({ $isLayout }) => ($isLayout ? '95%' : '125%')};
		max-height: ${({ $isLayout }) => ($isLayout ? '95%' : '125%')};
		object-fit: ${({ $isLayout }) => ($isLayout ? 'contain' : 'cover')};
		transform: translate3d(-50%, -50%, 0);
		z-index: 1;
	}
`;

export const LastImageCoverText = styled.div`
	${({ $isSmallText, theme }) => ($isSmallText ? theme.typography.textSemiBoldS : theme.typography.textBoldL)};
	position: absolute;
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	z-index: 2;
	background: #303cf680;
`;
